import { styled } from "@mui/material";

export const Section = styled('div')(({ theme }) => (props) => ({
    padding: '50px  4px 0',
    display: 'flex',
    alignItems: 'center',
    gap: '18px',
    flexWrap:'wrap'
}))